module.exports = __webpack_public_path__ + "static/menu-button-mobile-12b20e9afdfb07f33599f1a9a3db5c02.svg";